export default __webpack_public_path__ + "static/media/infinity.1a6feb7e.png";